export default "__VITE_ASSET__41a2071a__"